import { render } from "./AppPaginator.vue?vue&type=template&id=8cb92ea2"
import script from "./AppPaginator.vue?vue&type=script&lang=js"
export * from "./AppPaginator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__